module.exports = __webpack_public_path__ + "static/media/back.01b232cc.svg";